export default __webpack_public_path__ + "static/media/muliLogoSmall.b01cfbb3.png";